<template>
  <div v-if="list.length>0">
    <swiper :options="swiperOption" ref="mySwiperad" class="swiper-Container">
      <swiper-slide class="" v-for="(item,index) in list" :key="index">
        <a :href="item.contentUrl || '##'" class="swiper-Container-a">
          <img :src="item.imgUrl" alt>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  import 'swiper/css/swiper.min.css'
  import submit from '../../tool/submit'
  import utils from '../../tool/utils'

  export default {
    props: ['items', 'sid', 'topicID', 'uid'],
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        swiperOption: {},
        list: []
      }
    },
    created () {
      let _this = this
      if (_this.$route.query.cid) {
        submit.getTopicAdv({cid: _this.$route.query.cid, sid: _this.sid, uid: _this.uid || '0'})
          .then((response) => {
            if (response && response.data && response.data.length > 0) {
              let _list = []
              for (let i = 0, len = response.data.length; i < len; i++) {
                let item = response.data[i]
                // eslint-disable-next-line eqeqeq
                if (item.type == 12 && item.imgUrl) {
                  item.imgUrl = submit.handleImgScaleUrl(item.imgUrl, 'o')
                  // eslint-disable-next-line eqeqeq
                  if (item.adTopicType == 1 || item.adTopicType == 0 && (new RegExp('(\\b|,)' + _this.topicID + '(\\b|,)', 'g')).test(item.adTopicIDs)) {
                    // eslint-disable-next-line eqeqeq
                    if ((typeof item.adLinkType === 'undefined' || item.adLinkType == 1) && (item.contentUrl == null || item.contentUrl == '')) {
                      item.contentUrl = ''
                    } else {
                      // eslint-disable-next-line eqeqeq
                      if ((typeof item.adLinkType === 'undefined' || item.adLinkType == 1)) {
                        if (item.contentUrl.indexOf('http') < 0) {
                          item.contentUrl = 'http://' + item.contentUrl
                        }
                      } else {
                        // eslint-disable-next-line eqeqeq
                        item.contentUrl = utils.articleJumpUrl(_this.sid, item.adLinkType == 5 && 104 || item.adArticleType, item.articleID, (item.columnID || 0), item.articleLinkID, _this.$route.query.cid)
                      }
                    }
                  }
                  _list.push(item)
                }
              }
              if (_list.length > 0) {
                _this.list = _list
                _this.swiperOption = {
                  initialSlide: 0,
                  observeParents: true,
                  autoplay: _list.length > 1 && 4000 || 0,
                  autoHeight: true,
                  onlyExternal: true,
                  loop: _list.length > 1 && true || false
                }
              } else {
                _this.list = []
              }
            } else {
              _this.list = []
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    mounted () {
      // if (this.items.length === 1) {
        // document.getElementsByClassName('swiper-pagination-bullets')[0].style.display = 'none'
      // }
      // $('body').css({overflow: 'hidden'})
    }
  }
</script>
<style>

  .swiper-Container {
    width: 100%;
  }
  .swiper-Container .swiper-Container-a img{
    display: block;
    width: 100%;
    //max-width: 100%;
    max-height: 100%;
  }
  .swiper-Container-a {
    position: relative;
    display: block;
    width: 100%;
  }

  .s-c-title{
    font-size: 0.34rem;
    line-height: 0.57rem;
    padding: 0.2rem 0.3rem;
  }

  .s-c-hit{
    position: absolute;
    //display: inline-block;
    height: 23px;
    background: rgba(0, 0, 0, .5);
    color: #fff;
    line-height: 23px;
    text-align: center;
    font-size: 12px;
    padding: 0 8px;
    max-width: 70px;
    overflow: hidden;
    left: auto;
    right: 0;
    bottom: 25px;
    border-radius: 4px 0 0 4px;
  }

</style>



// WEBPACK FOOTER //
// Adswiper.vue?4bca6944